import { TableCell, TableRow } from "@mui/material";
import React from "react";

import useContactData from "@/hooks/data/use-contact-data";
import IContact from "@/interfaces/contact.interface";
import { ConsentStatusMessages } from "@/messages/consent-status.messages";

type Props = {
  contact: IContact;
  index: number;
  messages: ConsentStatusMessages;
};

function ContactRow({ contact, index, messages }: Props) {
  const data = useContactData({ messages, contact });
  const { fullName, phoneNumber, addressCity, addressStateUf, email } = data;

  return (
    <TableRow key={`contact-${index}`}>
      <TableCell>{fullName || "-"}</TableCell>
      <TableCell>{email || "-"}</TableCell>
      <TableCell>{phoneNumber || "-"}</TableCell>
      <TableCell>{addressCity || "-"}</TableCell>
      <TableCell>{addressStateUf || "-"}</TableCell>
    </TableRow>
  );
}

export default ContactRow;
